import React from 'react'
import { useSelector } from 'react-redux'
import { DataGrid } from '@mui/x-data-grid'
import { Box } from '../../../../../components/mui/Core/index'
import SummaryTablePagination from '../../../../../components/SummaryTablePagination/summary-table-pagination'
import { getNumberValueFormat } from '../../../../../utils/string-utils'
import SubHeader from '../../../../../components/SubHeader/sub-header'
import Constants from '../../../../../constants/en.json'
import { useTheme } from '../../../../../components/mui/Styles/index'

export function ItemCodeSummaryTable() {
  const theme = useTheme()
  const itemCodeSummary = useSelector((state) => state.itemCode.itemCodeSummary)
  const isFetchingItemCodeSummary = useSelector((state) => state.itemCode.isFetchingItemCodeSummary)
  const pageSize = 5
  const rowsPerPageOptions = 10
  const checkboxSelection = false

  const rows = itemCodeSummary.map((row) => ({
    id: row.itemCode,
    itemCode: row.itemCode,
    quantity: row.quantity,
    uom: row.uom,
  }))

  const rowsRendered = rows.length > 5 ? rows.slice(0, 5) : rows

  const columns = [
    {
      field: 'itemCode',
      headerName: Constants.inventory.ITEM_CODE,
      sortable: false,
      flex: 1,
      minWidth: 120,
    },
    {
      field: 'quantity',
      headerName: Constants.inventory.TOTAL_QTY,
      sortable: false,
      headerAlign: 'right',
      align: 'right',
      valueFormatter: (value) => {
        return getNumberValueFormat(value)
      },
      flex: 0.5,
      minWidth: 100,
    },
    {
      field: 'uom',
      headerName: Constants.inventory.UOM,
      sortable: false,
      flex: 0.4,
      minWidth: 80,
    },
  ]

  const boxStyle = {
    flexGrow: 1,
    mb: 10,
  }

  const itemCodeSummaryTableStyle = {
    ...theme.dataGridMiniTable,
    minHeight: '160px',
    height: isFetchingItemCodeSummary ? '400px' : 'auto',
  }

  return (
    <Box sx={boxStyle}>
      <SubHeader title={Constants.itemCodeSummary.ITEM_CODE_SUMMARY} />
      <DataGrid
        sx={itemCodeSummaryTableStyle}
        rows={rowsRendered}
        columns={columns}
        loading={isFetchingItemCodeSummary}
        pageSize={pageSize}
        rowsPerPageOptions={[rowsPerPageOptions]}
        checkboxSelection={checkboxSelection}
        disableRowSelectionOnClick
        slots={{
          pagination: SummaryTablePagination,
        }}
        slotProps={{
          pagination: {
            totalRowsCount: rows.length,
            rowsRenderedCount: rowsRendered.length,
            route: '/itemcodesummary',
          },
          loadingOverlay: {
            variant: 'skeleton',
            noRowsVariant: 'skeleton',
          },
        }}
      />
    </Box>
  )
}

export default ItemCodeSummaryTable
